import { CustomerTokenItem } from "./CustomerToken.item";

export class CustomerFocusKeyItem {
	pk: string; //CUSFOCKEY_:customerKey
	sk: string; //:NFCId
	token: string;
	venueKey: number;
	created: string;
	modified: string;

	customerTokenItem: CustomerTokenItem;

	public constructor(init?: Partial<CustomerFocusKeyItem>) {
		Object.assign(this, init);
	}
}
